// extracted by mini-css-extract-plugin
export default {"root":"OxNiCAq0nUswg8MhwalX","item":"pcrDvIXQ6xm7NGHVFv60","link":"atX3urZsgcX9MWtL_HV3","active":"RbEJ16yKAhmSfnLpEk8g","icon":"dnuwOS0sO_3pG47m9UKI"};